import PropTypes from "prop-types";
import React from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import FilledTextField from "./FilledTextField";

export const DateTimeRangeInput = ({
  label,
  onChangeFloor,
  onChangeCeil,
  floor,
  ceil,
  dateOnly,
  minDate,
  maxDate,
  InputGridProps,
  inputProps,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onChange = ({ target: { value } }, handler) => handler(value.trim());

  return (
    <Grid container item xs={12} md={6}>
      <Grid item xs={12} md={6} {...InputGridProps}>
        <FilledTextField
          style={{ width: isMobile ? "100%" : "calc(100% - 8px)" }}
          value={floor}
          label={`${label} ≥`}
          type={dateOnly ? "date" : "datetime-local"}
          underlineColor={theme.palette.text.lightgrey}
          onChange={(e) => onChange(e, onChangeFloor)}
          InputProps={{
            inputProps: {
              min: minDate,
              max: ceil,
              ...inputProps,
            },
          }}
        />
      </Grid>
      <Grid container item xs={12} md={6} justify="flex-end" {...InputGridProps}>
        <FilledTextField
          style={{ width: isMobile ? "100%" : "calc(100% - 8px)" }}
          value={ceil}
          label={`${label} ≤`}
          type={dateOnly ? "date" : "datetime-local"}
          underlineColor={theme.palette.text.lightgrey}
          onChange={(e) => onChange(e, onChangeCeil)}
          InputProps={{
            inputProps: {
              min: floor,
              max: maxDate,
              ...inputProps,
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

DateTimeRangeInput.propTypes = {
  label: PropTypes.string,
  onChangeFloor: PropTypes.func.isRequired,
  onChangeCeil: PropTypes.func.isRequired,
  floor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ceil: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dateOnly: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  InputGridProps: PropTypes.object,
  inputProps: PropTypes.object,
};

DateTimeRangeInput.defaultProps = {
  label: "",
  floor: undefined,
  ceil: undefined,
  dateOnly: false,
  minDate: "",
  maxDate: "",
  InputGridProps: {},
  inputProps: {},
};

export default DateTimeRangeInput;
